<mat-card appearance="outlined" *ngIf="!!dynamicContent">
  <h2>{{ 'dynamicContent.documents' | translate }}</h2>

  <div class="main-actions">
    <button (click)="chooseFromPDFAssets()" class="ibexfusion-raised-button small" mat-button>{{ 'dynamicContent.chooseDocument' | translate }}
    </button>
  </div>

  <div class="action-header" [ngClass]="{ active: !!selectedFiles?.length }">
    <div class="count">{{selectedFiles?.length}} {{'general.selectedEntries' + (selectedFiles.length > 1 ? 'Multi' : 'Single') | translate}}</div>

    <mat-form-field *ngIf="checkBoxActions">
      <mat-select [disabled]="!selectedFiles?.length" [placeholder]="'general.selectionActions' | translate">
        <mat-option (click)="action.action()" *ngFor="let action of checkBoxActions">
          <mat-icon *ngIf="action.icon">{{action.icon}}</mat-icon>
          {{action.translation | translate}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="table-header">
    <ibex-checkbox #checkboxAll [id]="'checkboxAll'" (click)="selectItemsAll()"></ibex-checkbox>
    <div class="preview"></div>
    <div class="title">{{'general.title' | translate}}</div>
    <div class="drag">
      <mat-icon>keyboard_arrow_up</mat-icon>
      <mat-icon>keyboard_arrow_down</mat-icon>
    </div>
    <div class="date">{{ 'general.created' | translate }}</div>
    <div class="size">{{'general.size' | translate}}</div>
    <div class="actions"></div>
  </div>

  <ng-container *ngIf="dynamicContent.lang === lang">
    <div (cdkDropListDropped)="dropFile($event)" cdkDropList class="table" *ngIf="dynamicContent?.dataFiles?.length">
      <div *ngFor="let file of dynamicContent.dataFiles; let i = index" cdkDrag cdkDragBoundary=".menu-item-list" class="table-row">
        <div *cdkDragPlaceholder class="drag-placeholder"></div>
        <ibex-checkbox (click)="selectItem(file)"></ibex-checkbox>
        <div class="preview"><ibex-icon name="adobe" variant="blank"></ibex-icon></div>
        <div class="title">{{ filesByPath[file.url]?.title || filesByPath[file.url]?.originalFileName }}</div>
        <div class="drag">
          <button class="drag ibexfusion-icon-button" mat-icon-button matTooltip="{{'packages.installedApps.dragTip'| translate}}">
            <mat-icon>drag_indicator</mat-icon>
          </button>
        </div>
        <div class="date">
          <ng-container *ngIf="filesByPath[file.url]?.created">{{ filesByPath[file.url].created | date:'dd.MM.YYYY' }}</ng-container>
        </div>
        <div class="size">
          <ng-container *ngIf="filesByPath[file.url]?.fileSize">{{ filesByPath[file.url].fileSize | fileSize }}</ng-container>
        </div>
        <div class="actions">
          <button (click)="editFile(i)" class="ibexfusion-icon-button" mat-icon-button>
            <mat-icon>edit</mat-icon>
          </button>
          <button (click)="downloadFile(i)" class="ibexfusion-icon-button" mat-icon-button>
            <mat-icon>download</mat-icon>
          </button>
          <button (click)="disconnectFile(i)" class="ibexfusion-icon-button" mat-icon-button>
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <p *ngIf="!dynamicContent?.dataFiles?.length" class="no-file">{{ 'dynamicContent.noDocuments' | translate }}</p>
  </ng-container>

  <ng-container *ngIf="dynamicContent.lang !== lang">
    <div (cdkDropListDropped)="dropFile($event)" cdkDropList class="table" *ngIf="translationEntries && translationEntries[lang]?.dataFiles?.length">
      <div *ngFor="let file of translationEntries[lang].dataFiles; let i = index" cdkDrag cdkDragBoundary=".menu-item-list" class="table-row">
        <div *cdkDragPlaceholder class="drag-placeholder"></div>
        <ibex-checkbox (click)="selectItem(file)"></ibex-checkbox>
        <div class="preview"><ibex-icon name="adobe" variant="blank"></ibex-icon></div>
        <div class="title">{{ filesByPath[file.url]?.title || filesByPath[file.url]?.originalFileName }}</div>
        <div class="drag">
          <button class="drag ibexfusion-icon-button" mat-icon-button matTooltip="{{'packages.installedApps.dragTip'| translate}}">
            <mat-icon>drag_indicator</mat-icon>
          </button>
        </div>
        <div class="date">
          <ng-container *ngIf="filesByPath[file.url]?.created">{{ filesByPath[file.url].created | date:'dd.MM.YYYY' }}</ng-container>
        </div>
        <div class="size">
          <ng-container *ngIf="filesByPath[file.url]?.fileSize">{{ filesByPath[file.url].fileSize | fileSize }}</ng-container>
        </div>
        <div class="actions">
          <button class="ibexfusion-icon-button" mat-icon-button>
            <mat-icon>edit</mat-icon>
          </button>
          <button (click)="disconnectFileTranslation(i, lang)" class="ibexfusion-icon-button" mat-icon-button>
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <p *ngIf="!(translationEntries && translationEntries[lang]?.dataFiles?.length)" class="no-file">{{ 'dynamicContent.noDocuments' | translate }}</p>
  </ng-container>
</mat-card>
